//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<template>
  <div class='content-wrapper'>
    <p class="some-text">Добро пожаловать, {{activeUser.Name}}!</p>

    <Row>
      <Col span="8">
        <news-widget>
        </news-widget>
      </Col>

      <Col span="8">
        <finix-tasks-widget>
        </finix-tasks-widget>
      </Col>
    </Row>
  </div>
</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<script>
import { mapGetters } from 'vuex'

import NewsWidget from './NewsWidget.vue'
import FinixTasksWidget from './FinixTasksWidget.vue'

export default {
  components: { NewsWidget, FinixTasksWidget },
  computed: {
    ...mapGetters([
      'activeUser'
    ])
  }
}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

<style scoped>
.content-wrapper{
  margin: 0px 0px 50px 0px;
  padding: 20px;
  /*overflow: hidden;*/
  background: #D9E0E7;
}
.some-text {
  font-family: "Roboto Light", sans-serif;
  font-size: 15px;
  padding: 0px 0px 20px 20px;
}
</style>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////



// WEBPACK FOOTER //
// MainDashboard.vue?55ebeb6d